const aud = new Intl.NumberFormat("en-AU", {
  style: "currency", currency: "AUD", minimumFractionDigits: 2, maximumFractionDigits: 2,
});

export const formatMoney = (value) => {
  const amount = Number(value ?? 0);
  return Number.isFinite(amount) ? aud.format(amount) : "—";
};